// DS — miernik siły hasła (MAPA 07, „Brak systemu” pkt 5; artboardy 13 i 15).
//
// Cztery słupki 4 px, trzy tony dla czterech kroków — „słabe / w drodze / dobre”
// (--danger-fg / --orange / --green); „pomarańcz kontra żółty” to rozróżnienie,
// którego nikt nie odczyta, więc nie istnieje. Renderuje się DOPIERO od pierwszego
// znaku (G2-auth-onboarding-16): cztery szare belki przy pustym polu to nie
// afordancja, tylko pusty tor obok pustego pola.
//
// `passwordStrength` liczy te same cztery reguły, które sprawdza backend
// (8 znaków, wielka litera, cyfra) plus znak specjalny — liczba słupków jest
// miarą postępu, nie oceną.

export function passwordStrength(value: string): 0 | 1 | 2 | 3 | 4 {
  // Four bars, four questions (artboard 13: one character = 1 of 4, „Ab1" = 2 of 4):
  // is there anything; is it 8+; does it carry the rule's digit AND capital; is there
  // more than the rule asks for (a symbol, or length past 12).
  if (!value) return 0
  let s = 1
  if (value.length >= 8) s++
  if (/[A-Z]/.test(value) && /[0-9]/.test(value)) s++
  if (/[^A-Za-z0-9]/.test(value) || value.length >= 12) s++
  return s as 0 | 1 | 2 | 3 | 4
}

export interface PasswordMeterProps {
  value: string
  className?: string
}

export function PasswordMeter({ value, className = '' }: PasswordMeterProps) {
  if (!value) return null
  const s = passwordStrength(value)
  return (
    <div className={['pw-meter', `lvl-${s}`, className].filter(Boolean).join(' ')} aria-hidden="true" data-strength={s}>
      {[0, 1, 2, 3].map((i) => <span key={i} className={i < s ? 'on' : undefined} />)}
    </div>
  )
}

export default PasswordMeter
